import React, { useEffect } from 'react';
import { Table } from 'react-bootstrap';
import lib from '../../../helpers/lib';
import Skeleton from 'react-loading-skeleton';
import '../styles.scss';

export default function AnaliticoMixClienteFaturamento(dados) {
  return (
    <div>
      <div className="table-responsive table-historico mt-4" onCopy={(e) => lib.parseCopiedText(e)}>
        {!dados?.isLoading && dados?.faturamentoClientesValores?.length > 0 ? (
          ([...dados?.faturamentoClientesValores] || [])?.map((vendedor, index) => (
            <div className="vendedor" key={index}>
              <p className="mb-3 fw-600" style={{ fontSize: '1.3em' }}>
                {vendedor.vendedorNome}
              </p>

              <Table striped bordered hover width="100%" className="table-relatorio">
                <thead>
                  <tr>
                    {/* <th>#</th> */}
                    <th>Cliente</th>
                    <th>Produto</th>
                    <th>
                      {lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado - 2)?.label}
                    </th>
                    <th>
                      {lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado - 1)?.label}
                    </th>
                    <th>{lib.selectListMeses.find((p) => p.value == dados?.mesFiltrado)?.label}</th>
                    <th>Total</th>
                  </tr>
                </thead>
                {vendedor?.clientes?.length > 0 ? (
                  ([...vendedor?.clientes] || [])?.map((cliente, indexCliente) => (
                    <tbody className="table-sem-totalizadores" key={indexCliente}>
                      <tr className="fw-600">
                        {/* <td></td> */}
                        <td>{cliente.clienteNome}</td>
                        <td>CNPJ: {cliente.clienteCnpj}</td>
                        <td>
                          {cliente.valorMesAntepenultimo?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                        <td>
                          {cliente.valorMesAnterior?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                        <td>
                          {cliente.valorMesAtual?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                        <td>
                          {cliente.valorTotalTrimestre?.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL'
                          })}
                        </td>
                      </tr>

                      {cliente?.produtos?.map((produto, produtoIndex) => (
                        <tr key={produtoIndex}>
                          {/* <td>{produtoIndex + 1}</td> */}
                          <td></td>
                          <td>{produto.produtoNome}</td>
                          <td>
                            {produto.valorMesAntepenultimo?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                          <td>
                            {produto.valorMesAnterior?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                          <td>
                            {produto.valorMesAtual?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                          <td>
                            {produto.valorTotalTrimestre?.toLocaleString('pt-br', {
                              style: 'currency',
                              currency: 'BRL'
                            })}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>Nenhum registro encontrado.</td>
                  </tr>
                )}
              </Table>

              {index + 1 < dados?.faturamentoClientesValores?.length ? (
                <hr className="my-5" />
              ) : null}
            </div>
          ))
        ) : (
          <Skeleton count={10} />
        )}
      </div>
    </div>
    // </Layout>
  );
}
